/** @typedef	{import('./Props').default} Props */

import React from 'react';
import SubscriptionCard from '../SubscriptionCard/SubscriptionCard';
import PremiumSubscriptionCard from '../SubscriptionCard/PremiumSubscriptionCard';

/**
 * @param {Props} props
 * @returns {JSX.Element}
 */
function SubscriptionPlans(props) {
	return (
		<section className="flex flex-col gap-4 lg:grid lg:grid-cols-3 ">
			{props?.tiers?.map((tier) => {
				if (
					tier.title === 'enterprise' ||
					tier.title === 'professional'
				) {
					return (
						<PremiumSubscriptionCard
							checkoutRole={props?.checkoutRole}
							isGettingData={props?.isGettingData}
							key={tier.title}
							paymentLinks={props?.paymentLinks}
							subscription={props?.subscription}
							tier={tier}
						/>
					);
				}

				return (
					<SubscriptionCard
						checkoutRole={props?.checkoutRole}
						isGettingData={props?.isGettingData}
						key={tier.title}
						paymentLinks={props?.paymentLinks}
						subscription={props?.subscription}
						tier={tier}
					/>
				);
			})}
		</section>
	);
}

export default React.memo(SubscriptionPlans);
